<template><DatasetFormEditor form-name="newDatasetForm" /></template>
<script>
import DatasetFormEditor from "./DatasetFormEditor.vue";
export default { name: "NewDatasetForm", components: { DatasetFormEditor } };
</script>
